export enum OrganizationUserRole {
    OWNER = "owner",
    ADMIN = "admin",
    MANAGER = "manager",
    MEMBER = "member",
}

export const organizationUserRolesInOrder = [
    OrganizationUserRole.OWNER,
    OrganizationUserRole.ADMIN,
    OrganizationUserRole.MANAGER,
    OrganizationUserRole.MEMBER,
] as const satisfies OrganizationUserRole[];

export enum OrganizationAction {
    CREATE_CLIENT = "create_client",
    UPDATE_CLIENT = "update_client",
    DELETE_CLIENT = "delete_client",
    MANAGE_CLIENT = "manage_client",
    INVITE_TEAM_MEMBER = "invite_team_member",
    CANCEL_INVITE = "cancel_invite",
    RESEND_INVITE = "resend_invite",
    MANAGE_ORGANIZATION_SETTINGS = "manage_organization_settings",
    VIEW_ORGANIZATION_BILLING = "view_organization_billing",
    MANAGE_ORGANIZATION_BILLING = "manage_organization_billing",
    MANAGE_CHART_OF_ACCOUNTS_TEMPLATES = "manage_chart_of_accounts_templates",
    MANAGE_ORGANIZATION_REPORT_SETTINGS = "manage_organization_report_settings",
    MANAGE_AGENT_SKILLS = "manage_agent_skills",
    VIEW_ORGANIZATION_MEMBER_ACCESS_LOG = "view_organization_member_access_log",
    VIEW_ORGANIZATION_ACTIVITY_LOG = "view_organization_activity_log",
    VIEW_AGENT_USAGE = "view_agent_usage",
}

const MEMBER_ACTIONS: readonly OrganizationAction[] = [];

const MANAGER_ACTIONS: readonly OrganizationAction[] = [
    ...MEMBER_ACTIONS,
    OrganizationAction.CREATE_CLIENT,
    OrganizationAction.UPDATE_CLIENT,
    OrganizationAction.MANAGE_CLIENT,
    OrganizationAction.INVITE_TEAM_MEMBER,
    OrganizationAction.CANCEL_INVITE,
    OrganizationAction.RESEND_INVITE,
    OrganizationAction.MANAGE_CHART_OF_ACCOUNTS_TEMPLATES,
    OrganizationAction.MANAGE_ORGANIZATION_REPORT_SETTINGS,
    OrganizationAction.MANAGE_AGENT_SKILLS,
];

const ADMIN_ACTIONS: readonly OrganizationAction[] = [
    ...MANAGER_ACTIONS,
    OrganizationAction.MANAGE_ORGANIZATION_SETTINGS,
    OrganizationAction.VIEW_ORGANIZATION_BILLING,
    OrganizationAction.VIEW_ORGANIZATION_MEMBER_ACCESS_LOG,
    OrganizationAction.VIEW_ORGANIZATION_ACTIVITY_LOG,
    OrganizationAction.VIEW_AGENT_USAGE,
];

const OWNER_ACTIONS: readonly OrganizationAction[] = [
    ...ADMIN_ACTIONS,
    OrganizationAction.MANAGE_ORGANIZATION_BILLING,
];

export const USER_ORGANIZATION_ROLE_ACTIONS: Record<
    OrganizationUserRole,
    readonly OrganizationAction[]
> = {
    [OrganizationUserRole.OWNER]: OWNER_ACTIONS,
    [OrganizationUserRole.ADMIN]: ADMIN_ACTIONS,
    [OrganizationUserRole.MANAGER]: MANAGER_ACTIONS,
    [OrganizationUserRole.MEMBER]: MEMBER_ACTIONS,
};
